(function() {
  'use strict';

  function BulkActionViewController(
    $q,
    $scope,
    $translate,
    Event,
    Form,
    Importer,
    User,
    Utils,
    TASK_NAMES
  ) {
    var ctrl = this;
    ctrl.TASKS_NAMES = TASK_NAMES;
    // eslint-disable-next-line max-len
    ctrl.mockRunInfoBelow = $translate.instant('We\'ve performed a <strong>mock run</strong> with your selected file. <strong>No records were actually created, updated or deleted!</strong><br/>The mock run results below represent what will likely happen if you were to run the actual import.');
    // eslint-disable-next-line max-len
    ctrl.mockRunInfoAbove = $translate.instant('We\'ve performed a <strong>mock run</strong> with your selected file. <strong>No records were actually created, updated or deleted!</strong><br/>The mock run results above represent what will likely happen if you were to run the actual import.');

    this.$onChanges = function(changes) {
      var bulkActionDoc = changes.bulkActionDoc.currentValue;
      if (bulkActionDoc) {
        if (!_.isUndefined(bulkActionDoc.dryrun)) {
          ctrl.dryrun = bulkActionDoc.dryrun;
        } else {
          // retro-compatibility
          ctrl.dryrun = bulkActionDoc.data.options.dryrun;
        }
      }
    };

    ctrl.getPreviewLabel = function(dryrun, state) {
      if (state === 'exists' || state === 'no_changes') {
        return $translate.instant(
          'Preview the {{docType}} which already exists.',
          { docType: ctrl.bulkActionDoc.data.docType }
        );
      }
      if (dryrun && state === 'created') {
        return $translate.instant(
          'Preview the {{docType}} which will be created',
          { docType: ctrl.bulkActionDoc.data.docType }
        );
      }
      if (dryrun && state !== 'created') {
        return $translate.instant(
          'Preview the {{docType}} which will be updated',
          { docType: ctrl.bulkActionDoc.data.docType }
        );
      }
      if (!dryrun && state === 'created') {
        return $translate.instant(
          'Preview the {{docType}} which was created',
          { docType: ctrl.bulkActionDoc.data.docType }
        );
      }
      return $translate.instant(
        'Preview the {{docType}} which was updated',
        { docType: ctrl.bulkActionDoc.data.docType }
      );
    };

    ctrl.getReadableState = function(state) {
      var _map = {
        created: 'Created',
        not_created: 'Not created',
        updated: 'Updated',
        exists: 'Exists',
        no_changes: 'Skipped',
        submitted: 'Submitted',
        errors: 'Failed',
        deleted: 'Deleted'
      };
      return _map[state];
    };

    ctrl.getReadableResult = function(state) {
      if (state === 'errors') {
        return;
      }

      var _map = {
        created: 'The record has been created',
        not_created: 'The record does not exists but has not been created because you decided ' +
          'not to',
        updated: 'A record has been found already and has been updated',
        exists: 'The record is already present',
        no_changes: 'The system tried to update that record but there were no changes',
        submitted: 'The record has been submitted',
        deleted: 'The record has been deleted'
      };

      return _map[state];
    };

    function getFutureStateFilterForm() {
      var states = {
        __all__: 'all',
        created: 'Created Records',
        not_created: 'Not Created Records',
        updated: 'Updated Records',
        exists: 'Existing Records',
        // no_changes: 'Not changed Records', // decided to merge it with exists
        submitted: 'Submitted Records',
        errors: 'Failed Records',
        deleted: 'Deleted Records'
      };
      var fields = [
        {
          id: 'filterState',
          type: 'discrete',
          label: $translate.instant('Show only'),
          options: _.map(states, function(name, key) {
            return { _id: key, key: key, name: name };
          }),
          defaultValue: '__all__',
          required: true
        }
      ];

      return new Form(fields);
    }

    ctrl.goToPage = function(page) {
      ctrl.onGoToPage({ page: page + 1 });
    };

    $scope.filterStateModel = {};
    ctrl.futureStateFilterForm = getFutureStateFilterForm();
    $scope.$watchCollection('filterStateModel', function(newFilterFutureState) {
      ctrl.outputFilterState({ filterState: newFilterFutureState.filterState });
    });

    function previewUser(userDoc) {
      var user = new User(userDoc);

      // we need the import meta data to be able to preview files because the object does
      // not exists yet and we need to check against the import object instead
      var meta = { dryrun: ctrl.dryrun, importerId: ctrl.bulkActionDoc._id };
      return user.openPreview(meta);
    }

    function previewEvent(eventDoc) {
      var event = new Event(eventDoc, { isLocal: false });
      return event.init()
        .then(function() {
          var options;
          if (!eventDoc._rev) {
            options = { parent: { doc: ctrl.bulkActionDoc }, dryrun: ctrl.dryrun };
          }
          event.openEventPreview(options);
        });
    }

    ctrl.preview = function(lineNumber) {
      // get the result for the line on the backend
      Importer.previewItem(ctrl.bulkActionDoc._id, lineNumber)
        .then(function(result) {
          if (result.errors) {
            return $q.reject(result.errors[0]);
          }

          var mapFunctions = { user: previewUser, event: previewEvent };
          return mapFunctions[result.doc.type](result.doc, result.files);
        })
        .catch(Utils.showError);
    };
  }

  BulkActionViewController.$inject = [
    '$q',
    '$scope',
    '$translate',
    'EventFactory',
    'FormsService',
    'ImporterService',
    'UserFactory',
    'UtilsService',
    'TASK_NAMES'


  ];

  angular.module('component.bulkActions')
    .component('bulkActionView', {
      templateUrl: 'app/components/bulk-actions/components/bulk-action-view.html',
      controller: BulkActionViewController,
      bindings: {
        bulkActionDoc: '<',
        onDownloadOutput: '&',
        onDelete: '&',
        onAbort: '&',
        onRetry: '&',
        onRunForReal: '&',
        outputFilterState: '&',
        outputTotal: '<',
        outputPage: '<',
        outputLimit: '<',
        outputStartKey: '<',
        onGoToPage: '&'
      }
    });
})();
